import React from 'react'
import PropTypes from 'prop-types'
import ClientProjectFinancialSummary from "./ClientProjectFinancialSummary";

const ClientProjectListItem = (props) => {

    const {project_id, name, canViewFinancialSummary} = props

    return (
        <div className="d-flex flex-row border-bottom pt-2 pb-1">
            <div className="d-flex flex-column" style={{flex: 1}}>
                <h5 className="mb-0">{project_id}</h5>
                <span className="font-weight-light">{name}</span>
            </div>
            {canViewFinancialSummary && <ClientProjectFinancialSummary {...props}/>}
        </div>
    )
}

ClientProjectListItem.propTypes = {
    project_id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    canViewFinancialSummary: PropTypes.bool
}

export default ClientProjectListItem